export default __webpack_public_path__ + "c49ccf9f1f334cbe547a25f539debc7b.png";